export const SCENARIO_FREQUENCY_DESCRIPTION = {
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annually: 'Annual',
    semi_annual: 'Semi Annual',
    one_time: 'One Time',
};
export const HYPOTHETICAL_TIMEFRAME_DESCRIPTION = {
    monthly: 'Month',
    quarterly: 'Quarter',
    yearly: 'Year',
    daily: 'Day',
};
// Hypothetical comparable types
export const COMPARABLE_BENCHMARK = 'benchmark';
export const COMPARABLE_SECURITY = 'security';
export const COMPARABLE_SCENARIO = 'scenario';
export const NO_COMPARABLE = 'no_comparable';
// Hypothetical Rate Of Return type
export const RATE_OF_RETURN_CAPM_EXPECTED = 'capm_expected_return';
export const RATE_OF_RETURN_TEN_YEAR = 'ten_year_return';
export const RATE_OF_RETURN_MONTE_CARLO = 'monte_carlo';
export const RATE_OF_RETURN_CUSTOM = 'custom';
// Scenario editor actions
export const SCENARIO_ACTION_ADD = 'add';
export const SCENARIO_ACTION_UPDATE = 'update';
// Scenario types
export const SCENARIO_CONTRIBUTION = 'contribution';
export const SCENARIO_WITHDRAWAL = 'withdrawal';
// Scenario data types
export const SCENARIO_PERC = 'perc';
export const SCENARIO_VALUE = 'value';
// Scenario frequency types
export const SCENARIO_MONTHLY = 'monthly';
export const SCENARIO_QUARTERLY = 'quarterly';
export const SCENARIO_YEARLY = 'annually';
export const SCENARIO_ONE_TIME = 'one_time';
export const SCENARIO_SEMI_ANNUAL = 'semi_annual';
// Scenario Rate of Change Data types
export const RATE_OF_CHANGE_PERCENTAGE = 'percentage';
export const RATE_OF_CHANGE_VALUE = 'value';
// Scenario Rate of Change Frequency types
export const RATE_OF_CHANGE_MONTHLY = 'monthly';
export const RATE_OF_CHANGE_QUARTERLY = 'quarterly';
export const RATE_OF_CHANGE_SEMI_ANNUAL = 'semi_annual';
export const RATE_OF_CHANGE_ANNUAL = 'annually';
// Scenario Module Chart Options
export const DOLLAR_COST_AVERAGING = 'dollar_cost_averaging';
export const RETIREMENT_WITHDRAWALS = 'retirement_withdrawals';
export const SAVED_SCENARIO = 'saved_scenario';
// Scenario editor dropdown configurations
export const TYPE_DROPDOWN_CONFIG = {
    list: [
        {
            type: 'option',
            label: 'Withdrawal',
            value: SCENARIO_WITHDRAWAL,
        },
        {
            type: 'option',
            label: 'Contribution',
            value: SCENARIO_CONTRIBUTION,
        },
    ],
};
export const DATA_TYPE_DROPDOWN_CONFIG = {
    list: [
        {
            type: 'option',
            label: 'Percentage',
            value: SCENARIO_PERC,
        },
        {
            type: 'option',
            label: 'Value',
            value: SCENARIO_VALUE,
        },
    ],
};
export const FREQUENCY_DROPDOWN_CONFIG = {
    list: [
        {
            type: 'option',
            label: 'Monthly',
            value: SCENARIO_MONTHLY,
        },
        {
            type: 'option',
            label: 'Quarterly',
            value: SCENARIO_QUARTERLY,
        },
        {
            type: 'option',
            label: 'Semi Annual',
            value: SCENARIO_SEMI_ANNUAL,
        },
        {
            type: 'option',
            label: 'Annually',
            value: SCENARIO_YEARLY,
        },
        {
            type: 'option',
            label: 'One Time',
            value: SCENARIO_ONE_TIME,
        },
    ],
};
export const RATE_OF_CHANGE_DATA_TYPE_DROPDOWN_CONFIG = {
    list: [
        {
            type: 'option',
            label: 'Percentage',
            value: RATE_OF_CHANGE_PERCENTAGE,
        },
        {
            type: 'option',
            label: 'Value',
            value: RATE_OF_CHANGE_VALUE,
        },
    ],
};
export const RATE_OF_CHANGE_FREQUENCY_DROPDOWN_CONFIG = {
    list: [
        {
            type: 'option',
            label: 'Monthly',
            value: RATE_OF_CHANGE_MONTHLY,
        },
        {
            type: 'option',
            label: 'Quarterly',
            value: RATE_OF_CHANGE_QUARTERLY,
        },
        {
            type: 'option',
            label: 'Semi Annual',
            value: RATE_OF_CHANGE_SEMI_ANNUAL,
        },
        {
            type: 'option',
            label: 'Annually',
            value: RATE_OF_CHANGE_ANNUAL,
        },
    ],
};
export const EMPTY_SCENARIO_ITEM = {
    name: '',
    value: '',
    dataType: undefined,
    type: undefined,
    frequency: undefined,
    startDate: undefined,
    endDate: undefined,
    rateOfChangeValue: undefined,
    rateOfChangeFrequency: undefined,
    rateOfChangeDataType: undefined,
    useTimeRangeFromAbove: true,
};
const MONTE_CARLO_WRONG_ALLOCATIONS_ERROR = "This investment's holdings don't fit the assumptions of YCharts Monte Carlo asset-class model. " +
    'When mapped to Stocks, Bonds, and Cash, the resulting allocation includes a negative value, which the model ' +
    'does not support.<br>Learn more about YCharts Monte Carlo methodology ' +
    "<a href='https://go.ycharts.com/knowledge-base/scenarios#faqs'>here</a>.";
export const ERROR_MESSAGES = {
    main_security_not_found: 'Security not found.',
    invalid_comparison_type: 'Invalid comparable type.',
    comparison_security_not_found: 'Comparison security not found.',
    comparison_scenario_not_found: 'Comparison scenario not found.',
    missing_security_id: 'Please select a valid Security.',
    missing_comparison_id: 'Please select a comparable.',
    missing_initial_investment: 'Please fill the Initial Investment.',
    missing_dates: 'Start Date and End Date are required.',
    missing_scenarios: 'You must add at least one scenario.',
    scenarios_not_a_list: 'You must add at least one scenario.',
    invalid_type: 'Invalid Type for Scenario in position %s.',
    invalid_scenario_frequency: 'Invalid Frequency for Scenario in position %s.',
    bad_start_date: 'Invalid Start Date for Scenario in position %s.',
    bad_end_date: 'Invalid End Date for Scenario in position %s.',
    invalid_value: 'Invalid Value for Scenario in position %s.',
    out_of_range_dates: 'The Start Date and End Date for Scenario in position %s must fall within the investment dates.',
    numbers_too_big: 'The values for the Scenario are too big. Please check the investment and scenarios configuration.',
    no_data_available: 'No data available for the selected security in the scenario dates.',
    internal_error: 'Internal error while building the scenario.',
    bad_saved_hypothetical: 'The selected Compare Scenario has errors.',
    invalid_rate_of_change_type: 'Invalid Rate of Change type for Scenario in position %s.',
    invalid_rate_of_change_value: 'Invalid Rate of Change value for Scenario in position %s.',
    invalid_rate_of_change_frequency: 'Invalid Rate of Change frequency for Scenario in position %s.',
    invalid_rate_of_return_type: 'Invalid expected rate of return type.',
    invalid_rate_of_return: 'Invalid rate of return value.',
    missing_capm_return: 'CAPM Expected Return metric not available for the selected security.',
    missing_ten_year_return: '10 Year Return metric not available for the selected security.',
    missing_std_dev_metric: 'Standard deviation metric not available for the selected security.',
    no_historical_return_data_available: 'Selected security does not have enough historical data to estimate future dates.',
    no_historical_level_data_available: 'Selected security does not have enough historical data to estimate future dates.',
    no_share_access_for_main_security: 'User does not have access to the selected Security.',
    no_feature_access_for_main_security: 'User does not have a to a required feature for the selected Security.',
    no_share_access_for_comparison_security: 'User does not have access to the selected compare Security.',
    no_feature_access_for_comparison_security: 'User does not have a to a required feature for the selected compare Security.',
    no_share_access_for_comparison_hypothetical: 'User does not have access to the selected compare Scenario.',
    no_feature_access_for_comparison_hypothetical: 'User does not have a to a required feature for the selected compare Scenario.',
    historical_performance_disabled: 'Historical performance dates are disabled',
    forward_looking_disabled: 'Forward looking dates are disabled',
    no_business_days: 'No business days found between initial and end dates.',
    negative_proportion: MONTE_CARLO_WRONG_ALLOCATIONS_ERROR,
    invalid_proportion: MONTE_CARLO_WRONG_ALLOCATIONS_ERROR,
    invalid_proportions: MONTE_CARLO_WRONG_ALLOCATIONS_ERROR,
};
// Default PDF title when exporting an unsaved hypothetical
export const DEFAULT_HYPOTHETICALS_PDF_TITLE = 'Scenario Builder';
export const DEFAULT_ERROR_MSG = 'An unknown error occurred, please try again.';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const HYPOTHETICALS_FOLDERABLE_APP_CONFIG = {
    appName: 'ScenariosApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Scenarios',
};
